import formatarData from '~js/formatar-data';

export default {
  install: function(Vue, options) {
    Vue.filter('formatarNumeroEmData', function(value, valorPadrao = '') {
      if (value) {
        return moment("1899-12-30").add(value, 'days').format('DD/MM/YYYY');
      }

      return valorPadrao;
    });
    
    Vue.filter('formatarDataEmNumero', formatarData.paraNumero);

    // Hora
    Vue.filter('formatarHora', function (data, retornarSeVazio = '') {
      if (data) {
        return moment(String(data)).format('HH:mm:ss');
      }

      return data || retornarSeVazio;
    });

    Vue.filter('formatarNumeroEmDataExtenso', function (value, valorPadrao = '') {
      if (value) {
        let aux = value - Math.trunc(value);
        aux = aux / (1 / 24);
        let hour = Math.trunc(aux);
        aux = (aux - hour) / (1 / 60);
        let min = Math.trunc(aux);
        aux = (aux - min) / (1 / 60);
        let seg = Math.trunc(aux);

        return moment("1899-12-30").add(Math.trunc(value), 'days').format('DD/MM/YYYY') + ' ' +
               ("0" + hour).slice(-2) + ':' + ("0" + min).slice(-2) + ':' + ("0" + seg).slice(-2);
      }

      return valorPadrao;
    });

  }
}



// WEBPACK FOOTER //
// ./FrontEnd/filtros/formatar-numero-data.js